import API from "@utils/request";
import { PAGE_SIZE } from "@config";

let Language = localStorage.getItem('currentLanguage');  //获取本地语言
let prout = 'protal';
if (!Language || Language == 'zh') {
  prout = 'protal';
} else {
  prout = 'protal_' + Language;
}

/**
 * 收藏列表
 * @param {object} params
 */
export async function getCollectionList(params) {
  try {
    return await API.post("/api/" + prout + "/api/userCenter/getCollectionList", params);
  } catch (error) {
    return error;
  }
}

/**
 * 获取用户信息
 * **/ 
export async function getUserInfo(params) {
  try {
    return await API.post("/api/" + prout + "/api/userCenter/userInfo", params);
  } catch (error) {
    return error;
  }
}

/**
 * userCenter/user_edit  编辑用户信息
 * **/ 
export async function userEdit(params) {
  try {
    return await API.post("/api/" + prout + "/api/userCenter/user_edit", params);
  } catch (error) {
    return error;
  }
}


/*
**userCenter/update_pwd  修改密码
**/
export async function updatePwd(params) {
  try {
    return await API.post("/api/" + prout + "/api/userCenter/update_pwd", params);
  } catch (error) {
    return error;
  }
}


/**
 * userCenter/activity  活动列表
 * **
 * */ 
export async function getActivity(params) {
  try {
    return await API.post("/api/" + prout + "/api/userCenter/activity", params);
  } catch (error) {
    return error;
  }
}


/**
 * userCenter/score  我的贡献值
 * **/ 
export async function getscore(params) {
  try {
    return await API.post("/api/" + prout + "/api/userCenter/score", params);
  } catch (error) {
    return error;
  }
}

/* 我的文章
* @param {object} params
*/

export async function article(params) {
  try {
    return await API.post("/api/" + prout + "/api/usercenter/article", params);
  } catch (error) {
    return error;
  }
 }
 /* 编辑我的文章
 * @param {object} params
 */
 
 export async function editArticle(params) {
   try {
     return await API.post("/api/" + prout + "/api/userCenter/userArticleEdit", params);
   } catch (error) {
     return error;
   }
  }

  /**
   * 删除我的文章
   * **/ 
 export async function DelArticle(params) {
   try {
     return await API.post("/api/" + prout + "/api/userCenter/userArticleDel", params);
   } catch (error) {
     return error;
   }
  }
/* 删除我的文章
    * @param {object} params
  */
  
export async function deleteArticle(params) {
  try {
    return await API.post("/api/" + prout + "/api/userCenter/userArticleDel", params);
  } catch (error) {
    return error;
  }
}

   /* 我的讨论列表
  * @param {object} params
*/

   export async function postList(params) {
    try {
      return await API.post("/api/" + prout + "/api/userCenter/post", params);
    } catch (error) {
      return error;
    }
  }

     /* 删除我的讨论
  * @param {object} params
*/

export async function deletePost(params) {
  try {
    return await API.post("/api/" + prout + "/api/userCenter/userPostDel", params);
  } catch (error) {
    return error;
  }
}

   /* 编辑我的讨论
  * @param {object} params
*/

   export async function editPost(params) {
    try {
      return await API.post("/api/" + prout + "/api/userCenter/userPostEdit", params);
    } catch (error) {
      return error;
    }
  }


  /***
   * userCenter/cancel_account  注销账号
   * **/ 

  export async function cancel_account(params) {
    try {
      return await API.post("/api/" + prout + "/api/userCenter/cancel_account", params);
    } catch (error) {
      return error;
    }
  }
 /***
   * cooperate/articleCollection  取消收藏
   * **/ 

 export async function setArticleCollection(params) {
  try {
    return await API.post("/api/" + prout + "/api/cooperate/articleCollection", params);
  } catch (error) {
    return error;
  }
}

